export enum WebhookStatus {
  Ok = 0,
  Error = 1,
  NoRegistration = 2,
  Mismatch = 3,
  NoActualRegistration = 4,
}

export interface RecruitNowWebhookOverviewItem {
  clientId: string;
  clientName: string;
  tenantId?: string | null;
  tenantName?: string | null;
  cockpitWebhookId?: string | null;
  registeredWebhookCount: number;
  webhookEnabled: boolean;
  webhookUri?: string | null;
  webhookErrorState?: string | null;
  webhookErrorMessage?: string | null;
  webhookFaultNotificationEmail?: string | null;
  hasMatchingRegistration: boolean;
  isModuleActive?: boolean;
  isMismatched: boolean;
  isSecretMismatched: boolean;
  isUriMismatched: boolean;
  isFiltersMismatched: boolean;
}

export interface PaginatedRecruitNowWebhookOverviewResponse {
  items: RecruitNowWebhookOverviewItem[];
  page: number;
  pageSize: number;
  totalCount: number;
}

export interface UseRecruitNowWebhookOverviewParams {
  tenantId?: string | null;
  clientType?: string[];
  page?: number;
  pageSize?: number;
  orderBy?: string;
  descending?: boolean;
  status?: WebhookStatus | null;
  search?: string;
}
